import { inject } from '@angular/core';
import { environment } from '../../../environments/environment';
import { StoreService } from '../store.service';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable, of } from 'rxjs';


export class ApiBaseService {

  accessToken: string = '';

  storeService: StoreService;
  httpClient: HttpClient;

  constructor(
  ) {
    this.storeService = inject(StoreService);
    this.httpClient = inject(HttpClient);

    this.storeService.getAuthToken().subscribe(
      (data: any) => { this.accessToken = data ? data['accessToken'] : null }
    )
  }

  GET(url: string, params?: HttpParams): Observable<any> {
    let headers: { [key: string]: string } = {
      'Content-Type': 'application/json'
    }
    if (this.accessToken) {
      headers['Authorization'] = `Bearer ${this.accessToken}`;
    }

    return this.httpClient.get<any>(url, {
      headers,
      params
    });
  }

  /**
   * Downloads a binary resource (image, PDF, ...) sending the auth header.
   */
  GETBLOB(url: string, params?: HttpParams): Observable<Blob> {
    let headers = new HttpHeaders();
    if (this.accessToken) {
      headers = headers.set('Authorization', `Bearer ${this.accessToken}`);
    }

    return this.httpClient.get(url, {
      headers,
      params,
      responseType: 'blob'
    });
  }

  POST(url: string, data: any, params?: HttpParams): Observable<any> {
    let headers: { [key: string]: string } = {
      'Content-Type': 'application/json'
    }
    if (this.accessToken) {
      headers['Authorization'] = `Bearer ${this.accessToken}`;
    }

    return this.httpClient.post<any>(url, data, {
      headers,
      params
    });
  }

  POSTMULTIPART(url: string, formData: FormData, params?: HttpParams): Observable<any> {
    let headers = new HttpHeaders();
    if (formData instanceof FormData) {
      if (this.accessToken) {
        headers = headers.set('Authorization', `Bearer ${this.accessToken}`);
      }

      return this.httpClient.post<any>(url, formData, {
        headers,
        params,
      });
    }

    return of({ error: 'Invalid FormData object provided' });
  }

  POSTUrlEncoded(url: string, urlSearchParams: URLSearchParams, params?: HttpParams): Observable<any> {
    let headers: { [key: string]: string } = {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
    if (this.accessToken) {
      headers['Authorization'] = `Bearer ${this.accessToken}`;
    }

    return this.httpClient.post<any>(url, urlSearchParams, {
      headers,
      params
    });
  }

  PUT(url: string, data: any, params?: HttpParams): Observable<any> {
    let headers: { [key: string]: string } = {
      'Content-Type': 'application/json'
    };

    if (this.accessToken) {
      headers['Authorization'] = `Bearer ${this.accessToken}`;
    }

    return this.httpClient.put<any>(url, data, {
      headers,
      params
    });
  }

  PUTMULTIPART(url: string, formData: FormData, params?: HttpParams): Observable<any> {
    let headers = new HttpHeaders();
    if (formData instanceof FormData) {
      if (this.accessToken) {
        headers = headers.set('Authorization', `Bearer ${this.accessToken}`);
      }
      return this.httpClient.put<any>(url, formData, {
        headers,
        params,
      });
    }

    return of({ error: 'Invalid FormData object provided' });
  }

  PATCH(url: string, data: any, params?: HttpParams): Observable<any> {
    let headers: { [key: string]: string } = {
      'Content-Type': 'application/json'
    };

    if (this.accessToken) {
      headers['Authorization'] = `Bearer ${this.accessToken}`;
    }

    return this.httpClient.patch<any>(url, data, {
      headers,
      params
    });
  }

  DELETE(url: string, params?: HttpParams): Observable<any> {
    let headers: { [key: string]: string } = {
      'Content-Type': 'application/json'
    }
    if (this.accessToken) {
      headers['Authorization'] = `Bearer ${this.accessToken}`;
    }

    return this.httpClient.delete<any>(url, {
      headers,
      params
    });
  }

  getUrl(path: string): string {
    return `${environment.apiBaseUrl}${path}`
  }
}
